import * as React from 'react'
import { StreamBroadcastStatus, StreamServiceType } from '../../../configs/stream-entities'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './BroadcastStatus.css'
import BroadcastState from './BroadcastState'

class BroadcastStatus extends React.Component<any, BroadcastState> {
    private broadcastStatusListener: firebase.Unsubscribe

    constructor(props: any) {
        super(props)
        this.state = new BroadcastState()
    }

    public componentDidMount() {
        this.broadcastStatusListener = firebase.firestore().collection('config').doc("StreamConfig").onSnapshot(doc => {
            if (doc.exists) {
                const updateState = new BroadcastState()
                const service = doc.data()!.activeService
                const broadcast = doc.data()!.broadcastStatus
                if (service === StreamServiceType.NONE) {
                    updateState.broadcastClass = "broadcastOff"
                } else if (broadcast === StreamBroadcastStatus.WAITINGROOM) {
                    updateState.broadcastClass = "broadcastWarm"
                } else if (broadcast === StreamBroadcastStatus.BROADCAST) {
                    updateState.broadcastClass = "broadcastOn"
                }
                this.setState(updateState)
            }
        })
    }

    public componentWillUnmount() {
        this.broadcastStatusListener()
    }

    public render() {
        return (<div className="BroadcastStatus">
            <div className={`broadcastFlag ${this.state.broadcastClass}`} />
        </div>)
    }
}
export default BroadcastStatus


// WEBPACK FOOTER //
// ./src/components/stream/broadcast/BroadcastStatus.tsx